<style lang="css">
@import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");
#dropzone{
    border: 2px dashed #e5e5e5;
}
div#top-spacer-big.row{
    height: 80px !important;
}
.page-header {
    border-bottom: 1px solid #EEE;
    margin: 10px 0;
    padding-bottom: 0;
}

body.home {
    background: #000 url("/static/img/stars_small.png") center center fixed no-repeat;
    width: 100%;
    height: 100%;
    background-size: cover;
    color: #fff;
}

span#bigger {
    font-weight: bolder;
}
/* Live Feed CSS */
/*pre.code-pre{
    background: #f3f3f3;
    max-height: 300px;
}
  .meta {
    color: #0;
    font-size: .85em;
  }

  .meta-bit {
    color: #b4bcc2;
    font-weight: bold;
  }

  span.badge.nohover.badge-light.badge-pill{
    background-color: #d1e3ff !important;
  }
  span.badge.nohover.yara-pill.badge-secondary.badge-pill{
    background-color: #7400c6 !important;
  }
.table-hover tbody tr:hover {
    background-color: rgba(255, 255, 255, 0.3);
}*/

</style>

<style scoped>
div.jumbotron.marquee {
  background-color: rgba(0,0,0,0.4);

}
a#rlink:hover {
    color: #ffffff !important;
    text-decoration: none;
    font-weight:bold !important;
  }
div#upload-settings.card.mb-2{
    border: 1px solid #bbbbbb;
/*    max-width: 69.5rem;
    min-width: 69.5rem;*/
}
a#link:hover {
        color: #0056b3 !important;
        text-decoration: none;
}
</style>

<template>
    <b-container class="bv-example-row">
    <div v-if="!authenticated">
        <div style="font-size: 5px; font-weight: 200;text-align: right;"><img src="/static/img/beta.png" alt="HOME" class="d-inline-block align-top" width="60" height="38" ></div>
        <b-jumbotron class="marquee">
          <template slot="header">
            <div v-if="!isMobile()">
                <b>UNPACME <img src="/static/img/unpacme_logo_white.png" alt="HOME" class="d-inline-block align-top" width="81" height="81" ></b>
            </div>
            <div v-else>
                <div style="font-size: 45px; font-weight: 500;">UNPACME <img src="/static/img/unpacme_logo_white.png" alt="HOME" class="d-inline-block align-top" width="51" height="51" ></div>
            </div>
          </template>
          <template slot="lead">
            <b>An automated malware unpacking service from <span id="bigger">OpenAnalysis</span></b>
          </template>
          <hr class="my-4">
          <p>
            UNPACME is an automated malware unpacking service. Submissions to UNPACME are analyzed using a set of custom unpacking processes maintained by OpenAnalysis. These processes extract all encrypted or packed payloads from the submission and return a unique set of payloads to the user. In short, UNPACME automates the first step in your malware analysis process.
          </p>
          <br>
          <span id="bigger" style="font-weight: 700;font-size: 20px">Public Beta</span>
          <p>
            UNPACME is currently operating as a public beta. We are continuously deploying new releases and testing new features. This may occasionally impact our service uptime and stability. As our processors receive more data our packer coverage is constantly improving. If we are unable to unpack a sample today, we probably will unpack it tomorrow! 
          </p>
          <b-btn variant="light" v-on:click="auth.signUp()">Sign Up</b-btn>
          <!-- <div><br><br></div> -->
        </b-jumbotron>
        <b-jumbotron style="background-color: rgba(0,0,0,0.4);" class="marquee2">
            <template slot="header">
                <div style="font-size: 30px;text-align: center;">UNPACME NEWS</div>
            </template>
            <hr class="my-3">
            <td>
                <tr v-for="postEntry in posts" v-bind:key="postEntry.id">
                    <b-card
                        img-top
                        tag="article"
                        style="color: #fffbfb; background-color: rgba(255,255,255,0.20)"
                        class="mb-3"
                    >
                        <b-card-title>{{postEntry.title}}</b-card-title>
                        <b-card-sub-title style="color:#c7c7c7!important"class="mb-2">{{postEntry.pubDate.split(" ")[0]}}</b-card-sub-title>
                        <b-card-text  style="color: white;">
                            {{postEntry.description}}
                            <br><br>
                            <div style="text-align: left;font-size: 15px;font-weight: bolder;"><a style="color:#95dcff" id="rlink" v-bind:href="postEntry.link" target="_blank">Read</a></div>
                        </b-card-text>
                    </b-card>
                </tr>
                <!-- This is crazy, we need to add a spacer row to force short articles to fill the full width -->
                <tr>
                    <b-card
                        img-top
                        tag="article"
                        style="color: black;opacity: 0;"
                        class="mb-3"
                    >
                        <b-card-title></b-card-title>
                        <b-card-sub-title class="mb-2"></b-card-sub-title>
                        <b-card-text  style="color: black;
                                                user-select: none;
                                                -webkit-touch-callout: none; /* iOS Safari */
                                                -webkit-user-select: none; /* Safari */
                                                 -khtml-user-select: none; /* Konqueror HTML */
                                                   -moz-user-select: none; /* Old versions of Firefox */
                                                    -ms-user-select: none;">
                            ----------------------------------------------------------------------------------------------------------------------------------------------------
                        </b-card-text>
                    </b-card>
                </tr>
            </td>
        </b-jumbotron>

    </div>
    <div v-if="authenticated && Object.keys(accessData).length">
        <b-row id="top-spacer-big">&nbsp;</b-row>
        <template v-if='accessData.roles.includes("admin")'>
            <div class="row" style="padding-left: 15px;padding-right: 15px;padding-bottom: 1px;padding-top: 1px;">
                <b-col></b-col>
                <b-col style="padding: 7px;" cols="6">
                    <b-card
                        title=""
                        img-top
                        id="upload-settings"
                        class="mb-2"
                    >
                        <b-card-sub-title style="text-align: center;" class="mb-2">
                            Admin Settings
                        </b-card-sub-title>
                        <hr style="background: white; margin-top: 1px; margin-bottom: 10px;">
                        <b-card-text>
                            <b-row>
                                <b-col >
                                    <b-form-checkbox v-model="aggressiveChecked" name="check-button" switch>
                                        Aggressive 
                                    </b-form-checkbox>
                                </b-col>
                                <b-col >
                                    <b-form-checkbox v-model="reprocessChecked" name="check-button" switch>
                                        Reprocess 
                                    </b-form-checkbox>
                                </b-col>
                                <b-col >
                                    <b-form-checkbox v-model="debugChecked" name="check-button" switch>
                                        Debug 
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                        </b-card-text>
                    </b-card>
                </b-col>
                <b-col></b-col>
            </div>
        </template>
        <template v-else>
            <b-row id="top-spacer-big">&nbsp;</b-row>
        </template>
        <b-row>
            <b-col></b-col>
            <b-col cols="6">
              <vue-dropzone ref="myVueDropzone" id="dropzone"
              :options="dropzoneOptions"
              :url="'http://localhost:1111'"
              :useCustomSlot=true
              @vdropzone-sending="dropzoneSendingEvent"
              @vdropzone-success="vsuccess"
              @vdropzone-removed-file="vremoved"
              @vdropzone-error="verror" >
                  <div class="dropzone-custom-content">
                    <b-img  rounded  width="175" height="175" :src="'/static/img/unpacme_logo_grey.png'" fluid alt="Responsive image" />
                    <h3 class="dropzone-custom-title">
                        <!--i class='fa fa-cloud-upload'></i--> Drop your file here to unpack!
                    </h3>
                    <div class="subtitle">We only support Windows PE32 executables...</div>
                    <div style="font-size: 12px;" class="subtitle">[Max size 20M]</div>
                  </div>
               </vue-dropzone>
            </b-col>
            <b-col></b-col>
        </b-row>
        <div class="row" style="padding-left: 15px;padding-right: 15px;padding-bottom: 1px;padding-top: 15px;">
            <b-col></b-col>
            <b-col style="padding: 7px;" cols="6">
                <b-card
                    title=""
                    img-top
                    id="upload-settings"
                    class="mb-2"
                >
                    <b-card-text>
                        <b-row>
                            <b-col >
                                <b-form-checkbox v-model="privateChecked" 
                                                :disabled='!accessData.roles.includes("admin") && !accessData.roles.includes("enterprise") && !accessData.roles.includes("partner") && !accessData.roles.includes("pro")'
                                                name="check-button" 
                                                :state="privateViewState" 
                                                id="privateOption"
                                                switch>
                                    <i class="fa fa-eye-slash"></i> Private 
                                </b-form-checkbox>
                                <b-tooltip target="privateOption" triggers="hover">
                                    Not available with your current <a id="link" href="/plans">plan</a>.  
                                </b-tooltip>
                            </b-col>
                        </b-row>
                        <b-row v-if='accessData.roles.includes("public") || accessData.roles.includes("researcher")'>
                            <b-col cols="6">
                                <div style="font-size: 10px; color: #6c757c;">Unavailable with your current <a id="link" href="/plans">plan</a></div>
                            </b-col>
                        </b-row>
                    </b-card-text>
                </b-card>
            </b-col>
            <b-col></b-col>
        </div>

    </div>
</b-container>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import axios from 'axios';

export default {
    props: ['auth', 'authenticated'],
    name: 'app',
    components: {
        vueDropzone: vue2Dropzone,
    },
    metaInfo() {
        return {
            title: 'UnpacMe',
            meta: [{ name: 'description', content: 'UnpacMe is an automated malware unpacking service. We provide malware analysis at Internet scale. Free for non-commercial use.' },
                { name: 'keywords', content: 'unpacking,unpacme,unpakme,unpackme,malware,malware analysis,analysis,automation,sandbox,oalabs,openanalysis,open analysis' }],
        };
    },
    created() {
        if (this.authenticated) {
            document.body.className = 'none';
            // add the auth token to the dropzone headers
            const tempBearer = this.getAuthBearer();
            this.dropzoneOptions.headers = { Authorization: tempBearer };
            this.getAccessData();
        } else {
            document.body.className = 'home';
            this.getPosts();
            // set timer for Live Feed
            // this.getFeed();
            // this.my_timer = setInterval(this.getFeed, 90000);
        }
    },
    beforeDestroy() {
        // Clear the timer
        clearInterval(this.my_timer);
    },
    data() {
        return {
            currentPage: 1,
            dropzoneOptions: {
                url: 'https://api.unpac.me/api/v1/private/upload',
                method: 'POST',
                thumbnailWidth: 200,
                addRemoveLinks: true,
                chunking: false,
                maxFiles: 1,
                maxFilesize: 20, // MB
                headers: { Authorization: '' },
            },
            // Live Feed controlling the timer and status display
            feedResults: [],
            my_timer: 0,
            posts: [],
            privateChecked: false, 
            aggressiveChecked: false, 
            reprocessChecked: false, 
            debugChecked: false, 
            accessData: {},
        };
    },
    computed: {
      privateViewState() {
        if (this.privateChecked) {
            return false
        }
        else {
            return null
        }
        
      }
    },
    notifications: {
        showSuccessMsg: {
            type: 'success',
            title: 'Hello there',
            message: 'That\'s the success!',
        },
        showInfoMsg: {
            type: 'info',
            title: 'Hey you',
            message: 'Here is some info for you',
        },
        showWarnMsg: {
            type: 'warn',
            title: 'Wow, man',
            message: 'That\'s the kind of warning',
        },
        showErrorMsg: {
            type: 'error',
            title: 'ERROR',
            message: 'That\'s the error',
            timeout: 30000,
        },
    },
    methods: {
        dropzoneSendingEvent(file, xhr, formData) {
            formData.append('private', this.privateChecked);
            formData.append('aggressive', this.aggressiveChecked);
            formData.append('reprocess', this.reprocessChecked);
            formData.append('debug', this.debugChecked);
        },
        isMobile() {
            if (navigator.userAgent.match(/Android/i) ||
            navigator.userAgent.match(/webOS/i) ||
            navigator.userAgent.match(/iPhone/i) ||
            navigator.userAgent.match(/iPad/i) ||
            navigator.userAgent.match(/iPod/i) ||
            navigator.userAgent.match(/BlackBerry/i) ||
            navigator.userAgent.match(/Windows Phone/i)) {
                return true;
            }
            return false;
        },
        vsuccess(file, response) {
            this.success = true;
            console.log(response);
            this.$router.push({ path: `/results/${response.id}` });

            // else{
            //   //Error condition
            //   this.$refs.myVueDropzone.removeFile(file)
            //   this.showErrorMsg({title:'File upload failed', message:"</br>"+response.msg.split(". ").join("</br>")})
            //   this.error = true
            // }
            // window.toastr.success('', 'Event : vdropzone-success')
        },
        verror(file, message, xhr) {
            console.log(`error ${file.name}`);
            console.log(message);
            this.$refs.myVueDropzone.removeFile(file);
            // Test if message is json or just a string
            if (message !== undefined && message !== null && message.constructor === Object) {
                // If this is a quota error then prompt user
                if (Object.prototype.hasOwnProperty.call(message, 'error') && message.error === 'submission_limit_exceeded') {
                    this.showErrorMsg({ title: 'Upload Failed', message: '</br>Monthly quota exceeded!<br><br> Increase your quota by selecting a <a style="color:white;font-weight:bold;" href="/plans">Plan Upgrade</a>' });
                } 
                // msg is json so check if there is a description for us 
                else if (Object.prototype.hasOwnProperty.call(message, 'description')) {
                    this.showErrorMsg({ title: 'Upload Failed', message: `</br>${message.description.split('. ').join('</br>')}` });
                } else {
                    this.showErrorMsg({ title: 'Upload Failed', message: '</br>Generic error.' });
                }
            } else if (message !== undefined && message !== null && message.constructor === String) {
                // msg is string so just print it as the error
                this.showErrorMsg({ title: 'Upload Failed', message: `</br>${message.split('. ').join('</br>')}` });
            } else {
                this.showErrorMsg({ title: 'Upload Failed', message: '</br>Generic error.' });
            }
            this.error = true;
            if (xhr.status === 401) {
                // Not authenticated pop login box
                this.auth.login();
            }
            // window.toastr.error(file.upload.filename, 'Event : vdropzone-error - ' + file.status)
        },
        vremoved(file, xhr, error) {
            this.removedFile = true;
            console.log(`removed ${file.name}`);
            // window.toastr.warning('', 'Event : vdropzone-removedFile')
        },
        getPosts() {
            const rss = "https://oalabs.openanalysis.net/tag/unpacme/rss";
            const data = { rss_url: rss};
            axios.get("https://api.rss2json.com/v1/api.json", { params: data })
            .then((response) => {
                // handle success
                const postsArray = response.data.items.slice(0, 3);
                this.posts = postsArray;
                console.log("Blog posts received!");
            })
            .catch(function(error) {
                // handle error
                console.warn(error);
            });

        },
        clickGoTo(sample) {
            window.location.href = `/results/${sample.id}`;
        },
        getAuthBearer() {
            this.accessToken = localStorage.getItem('access_token') || null;
            return `Bearer ${this.accessToken}`;
        },
        getAccessData() {
            const tempBearer = this.getAuthBearer();
            const path = 'https://api.unpac.me/api/v1/private/user/access';
            axios.get(path, { headers: { Authorization: tempBearer } })
                .then((res) => {
                    //console.log(res.data);
                    this.accessData = res.data;
                })
                .catch((error) => {
                    // eslint-disable-next-line
                    console.error(error);
                });
        },
    },


};
</script>



// WEBPACK FOOTER //
// src/components/Upload.vue